module.exports = __webpack_public_path__ + "img/gsxw_3.118436af.png";